import React, { useEffect } from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import blog1 from "../../images/blog1.jpg";
import blog2 from "../../images/blog2.png";
import blog3 from "../../images/blog3.jpg";
import blog4 from "../../images/blog4.jpg";
import shape14 from "../../images/shape-14.png";
import shape12 from "../../images/shape-12.png";
import call from "../../images/call.jpg";
import picture from "../../images/Picture1.png";
import picture5 from "../../images/Picture5.png";
import picture6 from "../../images/Picture6.png";

import shape21 from "../../images/shape-21.png";
import shape22 from "../../images/shape-22.png";
import Accordion from "react-bootstrap/Accordion";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
const Blog3 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Navbar/> */}

      <div class="section pageBanner" style={{ height: "15vh" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="page-banner-content">
              {/* <ul class="breadcrumb">
                 <li><a>Home</a></li>
                 <li class="active">Blog</li>
             </ul> */}
              {/* <h2 class="title" style={{color:'#fff'}}>How to Apply for an ECFMG Certification? </h2> */}
            </div>
          </div>
        </div>
      </div>
      <div className="container ">
        <div
          className="row"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="col-md-10">
            <h1
              class="title text-center"
              style={{
                color: "#0a083b",
                fontWeight: "700",
                padding: "0",
                lineHeight: "1.34",
                margin: "5px 0",
                fontSize: "48px",
              }}
            >
              How to Apply for an ECFMG Certification?
            </h1>
            {/* <p class=" text-center"> December 31,2022</p> */}
          </div>
        </div>
        <div
          className="row p-3"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="col-md-10">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img src={call} style={{ borderRadius: "10px" }} alt="" />
            </div>
            <div className="container">
              <div
                className="row"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="col-md-10">
                  <p
                    style={{
                      padding: "10px 0",
                      lineHeight: "1.8",
                      marginBottom: "1rem",
                      color: "#383838",
                      fontSize: "16px",
                      fontFamily: "Poppins",
                    }}
                  >
                    {" "}
                    You can apply for ECFMG Certification at any time,
                    regardless of your examination date. Maps Medics advises
                    International Medical Graduates to apply for ECFMG
                    certification before August 2023 to avoid the ECFMG 2024
                    deadline. Set enough time for your documents to be
                    processed, with a minimum of 45 days.{" "}
                  </p>
                  <div className="row p-3">
                    <div className="col-md-12">
                      <h1>Step 1: Prepare Your Documents</h1>
                      <ol style={{ listStyleType: "upper-alpha" }}>
                        <li>
                          Passport{" "}
                          <ul style={{ listStyleType: "disc" }}>
                            {" "}
                            <li>
                              Your passport name should be identical to your
                              medical school records, if a discrepancy is
                              present: contact your school administration or
                              issue a new passport (issuing a passport or
                              adjusting your name can be a timely process, so
                              plan accordingly. If you are yet to create a
                              passport, avoid using hyphens and spaces in a
                              single name e.g., D Write your name as
                              Abdelrahman, rather than Abd-elrahman or Abd
                              Elrahman. If you already issued your passport in
                              such a format, it would not be a vital issue, and
                              you shouldn’t proceed with editing your documents){" "}
                            </li>
                            <li>
                              If you do not have a passport, start issuing one
                              as soon as possible.
                            </li>
                          </ul>
                        </li>
                        <li>
                          {" "}
                          A Payment Method: Your Visa or Mastercard, which
                          should have a suitable online payment limit
                          (Application Price is 160$).
                        </li>
                        <li>
                          {" "}
                          For Graduates Only: Your graduation certificate, and
                          academic transcript.
                        </li>
                      </ol>
                      <h1>Step 2: Create an ECFMG ID</h1>
                      <ol style={{ listStyleType: "upper-alpha" }}>
                        <li>
                          If you are applying for USMLE for the first time, you
                          have to start by obtaining an ECFMG ID. To obtain this
                          ID, you have to visit this website,
                        </li>
                        <li>
                          From the home page, click on If you have never been
                          issued a USMLE/ECFMG Identification Number and want to
                          request one, click here, as shown in the screenshot
                        </li>
                        <img src={picture} alt="" />
                        <li>
                          Check the necessary boxes, and press next at the
                          bottom of the page
                        </li>
                        <li>
                          Choose “No, I have never submitted an Application for
                          ECFMG Certification or an application for examination
                          to ECFMG.” Then “Next”
                        </li>
                        <li>
                          Submit your Biographic Information:{" "}
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              Last Name: Write your Last Name Only. E.g., If
                              your name is Mohammed Hassan Khalil Omar Assem,
                              then your last name is Assem [and make sure your
                              name matches your passport and medical school
                              records]
                            </li>
                            <li>
                              Rest of the Name: Write Your first name(s) E.g.,
                              If your name is Mohammed Hassan Khalil Omar Assem,
                              then your first name(s) is Mohammed Hassan Khalil
                              Omar [and make sure your name matches your
                              passport and medical school records]
                            </li>
                            <li>Leave the Generational Suffix Blank</li>
                            <li>
                              Choose your Official Date of Birth from the menus.
                            </li>
                            <li>Choose your country of birth</li>

                            <li>Choose your Gender</li>
                            <li>
                              Leave Previously Issued USMLE ID and U.S. Social
                              Security Number Boxes Blank
                            </li>
                          </ul>{" "}
                        </li>
                        <li>
                          Submit Your Current/Degree Medical School
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              Choose Medical School Country and press Select
                            </li>
                            <li>Choose your university from the list</li>
                          </ul>
                        </li>
                        <li>
                          {" "}
                          Submit Your Contact Information
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Choose Your Country of Residence</li>
                            <li>
                              Write Your address
                              <ul style={{ listStyleType: "circle" }}>
                                <li>
                                  Street Address, Line 1: Apartment Number,
                                  Building Number, Street (e.g., Apartment 12,
                                  Building 43, Maps St.)
                                </li>
                                <li>
                                  Address, Line 2: District, City (e.g., 5th
                                  Settlement, New Cairo)
                                </li>
                                <li>
                                  Address, Line 3: Governorate (e.g., Cairo)
                                </li>
                              </ul>{" "}
                            </li>
                            <li>
                              Type Your E-mail address and verify it. (Use an
                              e-mail you have full access to)
                            </li>
                            <li>
                              Type your telephone number (Country code + Number
                              e.g., +20 01111111111)
                            </li>
                          </ul>
                        </li>
                        <li>
                          Check the “I certify that the information in this
                          ECFMG On-Line Authentication Process is true and
                          accurate and provided solely by me.” Box.
                        </li>
                        <li> Click Submit</li>
                        <li>
                          Check your e-mail (also your junk/spam tabs) regularly
                          for an e-mail from ECFMG, which can take up to a week
                        </li>
                        <li>
                          If you have not received your ECFMG ID within a week,
                          use the following details to contact the ECFMG
                        </li>
                        <img src={picture5} alt="" />

                        <li>
                          Once you receive your ECFMG ID, visit this website.
                          However, choose If you have a USMLE/ECFMG
                          Identification Number, but you are a first-time user
                          of ECFMG On-line Services, click hereto establish an
                          account.
                        </li>
                        <img src={picture} alt="" />

                        <li>Repeat the same steps from C to I</li>
                        <li>Choose a password for your ECFMG Account</li>
                        <li>Login to your new account from here</li>
                      </ol>
                      <h1>Step 3: Application for ECFMG Certification</h1>
                      <ol style={{ listStyleType: "upper-alpha" }}>
                        <li>Prepare your Visa/MasterCard</li>
                        <li>Login to your account from here</li>

                        <li>
                          Once you log in, from the left side of the screen,
                          under IWA links, choose Apply from the options below
                          Application for ECFMG Certification.
                        </li>
                        <img src={picture6} alt="" />

                        <li>
                          Enter Your Personal Data as described before, and make
                          sure your name matches your passport and medical
                          school records, and submit your Medical Education
                          status
                        </li>
                        <li>Pay the required amount (160$)</li>
                        <li>
                          Upon successful payment, you will be able to download
                          the “Certification of Identification Form – Form 186”
                          on your computer.
                        </li>
                      </ol>
                      <h1>Step 4: Notary Cam</h1>
                      <ol style={{ listStyleType: "upper-alpha" }}>
                        <li>Open to the Notary Cam website</li>
                        <li>
                          Click on “Click here to complete your certification
                          186 identification form”
                        </li>

                        <li>
                          Enter your personal details, as previously submitted
                          to the ECFMG website
                        </li>
                        {/* <img src={picture6} alt="" /> */}

                        <li>
                          Upload your filled Form 186 and a scan of your
                          passport identification page
                        </li>
                        <li>
                          You will receive an e-mail to schedule your Notary Cam
                          appointment
                        </li>
                        <li>
                          On your appointment day, make sure you have a stable
                          internet connection, a working webcam, and your
                          passport in hand
                        </li>
                        <li>
                          Within 10 working days, you will receive an e-mail
                          from ECFMG confirming that your documents have been
                          received
                        </li>
                        <li>
                          {" "}
                          Your Notary Cam verification is valid for 5 years;
                          however, you can renew it with ease and it will not
                          cause any trouble for candidates who are required to
                          revalidate. Do not delay this step.
                        </li>
                      </ol>

                      <h1>Step 5: Medical School Verification</h1>
                      <ol style={{ listStyleType: "upper-alpha" }}>
                        <li>
                          This step is not required before applying to a USMLE
                          Step but is necessary before an ECFMG certificate is
                          about to be issued (after you have taken USMLE Step 1,
                          Step 2 CK, and an OET)
                        </li>
                        <li>
                          Kindly note that you should not wait more than 7 years
                          between Step 1 and Step 2 CK
                        </li>

                        <li>
                          {" "}
                          Once this step is due, contact your medical school
                          administration for verification of your medical school
                          credentials
                        </li>
                        {/* <img src={picture6} alt="" /> */}

                        <li>
                          You may not submit the credentials required for ECFMG
                          Certification to ECFMG until you apply for an exam. If
                          you send credentials to ECFMG before you apply for an
                          exam, they will not be processed.
                        </li>
                      </ol>
                    </div>
                  </div>
                  {/* <h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>When can I take the USMLE Step 1 exam? </h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>Generally speaking, students take the Step 1 exam between their second and third years in medical school. However, since Step 1 became pass/fail in January 2022, many students began writing their Step 1 exam earlier in the M2 year than usual. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>Students who follow an untraditional curriculum typically take the test after they take their NBME® Shelf exams. It’s also possible to take Step 2 CK before Step 1, but this happens less often. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>The USMLE Step 1 exam is available to take for most of the year except for major holidays. You can keep track of any test center closures here. </p>
<h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>Who is eligible to take Step 1?  </h2>
<ul style={{listStyleType:'disc'}}>
    <li>
    US & Canada MDs: Students officially enrolled in, or a graduate of, an LCME-accredited medical school in the US or Canada who will receive an MD degree are eligible to take the Step 1 exam. 
    </li>
    <li>US DOs: Students officially enrolled in, or a graduate of, a COCA-accredited medical school in the US who will receive a DO degree are eligible to take the Step 1 exam. </li>
    <li>IMGs: Students officially enrolled in, or a graduate of, a medical school outside the US and Canada that is listed in the World Directory of Medical Schools and meets ECFMG eligibility requirements are eligible to take the Step 1 exam. 
</li>
</ul> */}
                  {/* <h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>How do I register for Step 1? </h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>Eligible applicants from US or Canadian schools can apply through the NBME application website. To get started, you must register as a first-time user. Once this is done, you’ll receive your USMLE ID by email. This is the ID you’ll use to register for future USMLE exams. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>You can then apply for the USMLE, select a new application, and choose your testing period. Following your application, the NBME will email you with your scheduling permit and the period in which you can sit the exam. You can then schedule your test date through the Prometric website.</p>
<h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>How far in advance can I schedule my Step 1 exam date? </h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>You can schedule your Step 1 exam through the Prometric website as far as six months in advance. When applying for the exam, you must select an eligibility period. This is the window through which you will take the exam. The eligibility period lasts three months. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>If your exam is coming up fast, check out our 30-day high-yield study plan. It covers 30 of the highest-yield topics that you’ll need to know for exam day so you can streamline your studies and maximize your time. </p>
<h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>How much does it cost to register for Step 1?  </h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>The cost of registration is $645 (for students taking Step 1 in the US) which can be paid with a credit card. The application fee is non-refundable. If for some reason you don’t sit the exam within your eligibility period, you’ll have to reapply with a new application. The eligibility extension costs $70.  </p>
<h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>How can I change my Step 1 exam date?   </h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>If you have already scheduled your Step 1 exam date, you can reschedule it on the Prometric website here. </p>
<h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>Will my Step 1 exam date be affected by COVID-19? </h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>While Prometric centers and testing have largely returned to full capacity, you can keep an eye on any test center closures on the Prometric website here. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>According to the website, “a limited number of Prometric test centers will require candidates to present proof of vaccination in order to test.” You can learn more about the requirements of individual test centers here. </p>
<h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>When will I get my Step 1 results? </h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>According to the USMLE, results for Step 1 are usually available within two to four weeks after the test date. However, it’s possible that it may take longer than this. If there is a delay for some reason, the USMLE states you should wait at least eight weeks before inquiring about your grade. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}> Once your report becomes available, you’ll be notified by email and can follow the online instructions to access it. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>To learn more about taking Step 1 as a pass/fail exam, check out this article with advice from a Step 1 test-taker in the era of pass/fail. </p>
<h2 style={{lineHeight:'1.6', fontWeight:'500', marginBottom:'20px', fontFamily:'Poppins', fontSize:'32px'}}>Preparing for the exam</h2>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>While there is no one-size-fits-all approach to studying for Step 1, there are a few key points that will apply to almost all students. Firstly, remember that it’s a marathon, not a sprint. It’s important to build up your knowledge base steadily and consistently. With that in mind, be sure to make the most of your dedicated study time, if your university offers it. You can use this time to pass through Qbanks such as AMBOSS to enhance your learning and practice your test-taking skills (the AMBOSS Exam Mode feature that replicates NBME exam-day conditions is particularly useful for this). </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>Self-assessments are another great way to prepare for Step 1. You can find self-assessments on a number of different learning platforms. If you are interested in taking a timed self-assessment that is representative of the real exam, you should sign up here for the annual AMBOSS Step 1 self-assessment. After completing the self-assessment, you’ll receive a breakdown of your strengths and weaknesses,  study recommendations, and (because so many students still want one!) a 3-digit score so you can benchmark your progress. And it’s completely free to take!</p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>You can also prepare for Step 1 (or any exam) with the AMBOSS Study Planner. With the planner, you can create a personalized Step 1 study plan that’s adapted to your schedule and learning objective. It only takes seconds to set up and it will identify the areas you need to focus on the most with a personalized analysis. </p>
<p style={{padding:'10px 0', lineHeight:'1.8',marginBottom:'1rem' ,color:'#383838', fontSize:'16px', fontFamily:'Poppins'}}>Preparing for exams or practicing in the clinic? No matter what stage you’re at, we’ve got you covered. Start your free AMBOSS trial today. </p> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-md-6">
         <h5><i class="fa-solid fa-check-double" style={{color:'#ffc600'}}></i>
        </h5>
       
        </div> */}
        </div>

        <div className="row p-3">
          {/* <div class="footer-widget-section"> */}

          {/* <img class="shape-1 animation-down" src={shape21} alt="Shape"/> */}

          {/* <div class="container">
    <div class="row">
    <Accordion defaultActiveKey="0">
  <Accordion.Item eventKey="0">
    <Accordion.Header style={{color:'#ffc600'}}>When can I take the USMLE Step 1 exam? </Accordion.Header>
    <Accordion.Body style={{color:'#ffc600'}}>
    Generally speaking, students take the Step 1 exam between their second and third years in medical school. However, since Step 1 became pass/fail in January 2022, many students began writing their Step 1 exam earlier in the M2 year than usual. 

Students who follow an untraditional curriculum typically take the test after they take their NBME® Shelf exams. It’s also possible to take Step 2 CK before Step 1, but this happens less often. 

The USMLE Step 1 exam is available to take for most of the year except for major holidays. You can keep track of any test center closures here.     </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="1">
    <Accordion.Header style={{color:'#ffc600'}}>Who is eligible to take Step 1? 
</Accordion.Header>
    <Accordion.Body style={{color:'#ffc600'}}>
    US & Canada MDs: Students officially enrolled in, or a graduate of, an LCME-accredited medical school in the US or Canada who will receive an MD degree are eligible to take the Step 1 exam. 
US DOs: Students officially enrolled in, or a graduate of, a COCA-accredited medical school in the US who will receive a DO degree are eligible to take the Step 1 exam. 
IMGs: Students officially enrolled in, or a graduate of, a medical school outside the US and Canada that is listed in the World Directory of Medical Schools and meets ECFMG eligibility requirements are eligible to take the Step 1 exam.     </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>How do I register for Step 1?
</Accordion.Header>
    <Accordion.Body style={{color:'#ffc600'}}>
    Eligible applicants from US or Canadian schools can apply through the NBME application website. To get started, you must register as a first-time user. Once this is done, you’ll receive your USMLE ID by email. This is the ID you’ll use to register for future USMLE exams. 

You can then apply for the USMLE, select a new application, and choose your testing period. Following your application, the NBME will email you with your scheduling permit and the period in which you can sit the exam. You can then schedule your test date through the Prometric website.     </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="3">
    <Accordion.Header>How far in advance can I schedule my Step 1 exam date? </Accordion.Header>
    <Accordion.Body style={{color:'#ffc600'}}>
    You can schedule your Step 1 exam through the Prometric website as far as six months in advance. When applying for the exam, you must select an eligibility period. This is the window through which you will take the exam. The eligibility period lasts three months. 

If your exam is coming up fast, check out our 30-day high-yield study plan. It covers 30 of the highest-yield topics that you’ll need to know for exam day so you can streamline your studies and maximize your time.       </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="4">
    <Accordion.Header>How much does it cost to register for Step 1? </Accordion.Header>
    <Accordion.Body style={{color:'#ffc600'}}>
    The cost of registration is $645 (for students taking Step 1 in the US) which can be paid with a credit card. The application fee is non-refundable. If for some reason you don’t sit the exam within your eligibility period, you’ll have to reapply with a new application. The eligibility extension costs $70.   </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="5">
    <Accordion.Header>How can I change my Step 1 exam date? </Accordion.Header>
    <Accordion.Body style={{color:'#ffc600'}}>
    If you have already scheduled your Step 1 exam date, you can reschedule it on the Prometric website here.  </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="6" style={{color:'#ffc600'}}>
    <Accordion.Header>Will my Step 1 exam date be affected by COVID-19? </Accordion.Header>
    <Accordion.Body>
    While Prometric centers and testing have largely returned to full capacity, you can keep an eye on any test center closures on the Prometric website here. 

According to the website, “a limited number of Prometric test centers will require candidates to present proof of vaccination in order to test.” You can learn more about the requirements of individual test centers here. </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="7" style={{color:'#ffc600'}}>
    <Accordion.Header>When will I get my Step 1 results? </Accordion.Header>
    <Accordion.Body>
    According to the USMLE, results for Step 1 are usually available within two to four weeks after the test date. However, it’s possible that it may take longer than this. If there is a delay for some reason, the USMLE states you should wait at least eight weeks before inquiring about your grade. 

Once your report becomes available, you’ll be notified by email and can follow the online instructions to access it. 

To learn more about taking Step 1 as a pass/fail exam, check out this article with advice from a Step 1 test-taker in the era of pass/fail.  </Accordion.Body>
  </Accordion.Item>
 
</Accordion>
    </div>
</div> */}

          {/* <img class="shape-2 animation-left" src={shape22} alt="Shape"/> */}

          {/* </div> */}
        </div>
        {/* <div className="row p-3">
<h1>Preparing for the exam</h1>
<div className="col-md-6">
    <h5><i class="fa-solid fa-check-double" style={{color:'#ffc600'}}></i>
    While there is no one-size-fits-all approach to studying for Step 1, there are a few key points that will apply to almost all students. Firstly, remember that it’s a marathon, not a sprint. It’s important to build up your knowledge base steadily and consistently. With that in mind, be sure to make the most of your dedicated study time, if your university offers it. You can use this time to pass through Qbanks such as AMBOSS to enhance your learning and practice your test-taking skills (the AMBOSS Exam Mode feature that replicates NBME exam-day conditions is particularly useful for this). 
    </h5>
</div>
<div className="col-md-6">
    <h5><i class="fa-solid fa-check-double" style={{color:'#ffc600'}}></i>
    Self-assessments are another great way to prepare for Step 1. You can find self-assessments on a number of different learning platforms. If you are interested in taking a timed self-assessment that is representative of the real exam, you should sign up here for the annual AMBOSS Step 1 self-assessment. After completing the self-assessment, you’ll receive a breakdown of your strengths and weaknesses,  study recommendations, and (because so many students still want one!) a 3-digit score so you can benchmark your progress. And it’s completely free to take!
    </h5>
</div>
<div className="col-md-12 p-3">
    <h5><i class="fa-solid fa-check-double" style={{color:'#ffc600'}}></i>You can also prepare for Step 1 (or any exam) with the AMBOSS Study Planner. With the planner, you can create a personalized Step 1 study plan that’s adapted to your schedule and learning objective. It only takes seconds to set up and it will identify the areas you need to focus on the most with a personalized analysis. </h5>
    <h5><i class="fa-solid fa-check-double" style={{color:'#ffc600'}}></i>Preparing for exams or practicing in the clinic? No matter what stage you’re at, we’ve got you covered. Start your free AMBOSS trial today. </h5>
</div>
</div> */}
      </div>
      <div class="section section-padding">
        <div class="container">
          <div class="contact-wrapper">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <div class="contact-info">
                  <img
                    class="shape animation-round"
                    src={shape12}
                    alt="Shape"
                  />
                  <h2>Leave A Reply</h2>

                  <div class="single-contact-info">
                    <div class="info-content">
                      <h6 class="title">Comment *</h6>

                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Comment"
                      />
                    </div>
                  </div>

                  <div class="single-contact-info">
                    <div class="info-content">
                      <h6 class="title">Name *</h6>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                      />
                    </div>
                  </div>

                  <div class="single-contact-info">
                    <div class="info-content">
                      <h6 class="title">Email *</h6>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>

                  <div class="single-contact-info">
                    <div class="info-content">
                      <h6 class="title">Website</h6>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Website"
                      />
                    </div>
                  </div>
                  <button
                    class="btn btn-primary "
                    style={{
                      backgroundColor: "#FFC600",
                      border: "#FFC600",
                      borderRadius: "20px",
                      float: "right",
                    }}
                  >
                    Post Comment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Blog3;
